import React, { useState } from "react";
import { Box, Button, Grid, Link, TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import { Container } from "@mui/material";
import Sella from "./Sella.png";
import axios from "axios";
import Url from "../services/Url";
import { useSharedStore } from "../services/SharedStore";
import { useNavigate } from "react-router-dom";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import { useEffect } from "react";

const CssTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      height: "45px",
      border: "solid 1px #ccc",
    },
    "& input": {
      padding: "10px",
    },
  },
});

const Intestazione = styled(Box)({
  fontFamily: "Montserrat",
  fontSize: "31px",
  fontWeight: "normal",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "normal",
  textAlign: "center",
  color: "#1b1b1b",
});

const CompilaCampi = styled(Box)({
  fontFamily: "Lato",
  fontSize: "15px",
  fontWeight: "normal",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "0.11px",
  textAlign: "center",
  color: "#7b7b7b",
});

const ReimpostaUserName = styled(Box)({
  fontFamily: "Lato",
  fontSize: "18px",
  fontWeight: "normal",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "0.13px",
  textAlign: "center",
  color: "#4d606f",
});

const TextFields = styled(Grid)({
  marginTop: "42px",
});

const Errors = styled(Box)({
  fontFamily: "Lato",
  fontSize: "14px",
  fontWeight: "bold",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "1.29",
  letterSpacing: "0.1px",
  color: "#f2662b",
});

const DivImportante = styled(Box)({
  padding: "7px 0px 0px 0px",
  height: "71px",
  backgroundColor: "#e8f5ff",
});

const ContenutoDiv = styled(Box)({
  marginTop: "23px",
  fontFamily: "Lato",
  fontSize: "14px",
  fontWeight: "normal",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "1.57",
  letterSpacing: "0.1px",
  textAlign: "center",
  color: "#4d606f",
});

const BloccoImportante = styled(Grid)({
  marginTop: "28px",
});

const Buttons = styled(Grid)({
  marginTop: "36px",
});

const UpButton = styled(Button)({
  borderRadius: "0px",
  height: "50px",
  boxShadow: "none",
  textTransform: "none",
  fontFamily: "Montserrat",
  fontSize: "12px",
  fontWeight: "600",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "0.09px",
  textAlign: "center",
  color: "#fff",
  backgroundColor: "#339aef",
  "&:hover": {
    backgroundColor: "#339aef",
  },
  "&:active": {
    backgroundColor: "#339aef",
  },
  "&:focus": {
    backgroundColor: "#339aef",
  },
});

const BackButton = styled(Button)({
  borderRadius: "0px",
  height: "50px",
  boxShadow: "none",
  textTransform: "none",
  fontFamily: "Montserrat",
  fontSize: "12px",
  fontWeight: "600",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "0.09px",
  textAlign: "center",
  color: "#fff",
  backgroundColor: "#4d606f",
  "&:hover": {
    backgroundColor: "#4d606f",
  },
  "&:active": {
    backgroundColor: "#4d606f",
  },
  "&:focus": {
    backgroundColor: "#4d606f",
  },
});

const HelperText = styled(Box)({
  marginTop: "168px",
  fontFamily: "Lato",
  fontSize: "13px",
  fontWeight: "normal",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "1.54",
  letterSpacing: "0.09px",
  textAlign: "center",
  color: "#919191",
});

const ContactLink = styled(Link)({
  fontFamily: "Lato",
  fontSize: "13px",
  fontWeight: "bold",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "1.54",
  letterSpacing: "0.09px",
  textAlign: "center",
  color: "#00cb4d",
});

const Informativa = styled(Box)({
  marginBottom: "36px",
  opacity: "0.5",
  fontFamily: "Lato",
  fontSize: "13px",
  fontWeight: "normal",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "0.09px",
  textAlign: "center",
  color: "#333",
});

const SimpleBox = styled(Box)({
  textAlign: "center",
});

function MakeNewUserName() {
  const [loading, setloading] = useState(false);
  const [UserError, setUserErr] = useState("");
  const [confirmUserNameError, setConfirmUserNameError] = useState("");
  const [userName, setUserName] = useState("");
  const [confirmUserName, setConfirmUserName] = useState("");
  const { getStore } = useSharedStore();
  let navigate = useNavigate();

  useEffect(() => {
    setloading(false);
    window.scrollTo(0, 0);
  }, []);

  const close = () => {
    navigate("/");
  }

  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const [showPassword2, setShowPassword2] = React.useState(false);
  const handleClickShowPassword2 = () => setShowPassword2((show) => !show);

  const handleValidation = (evnt) => {
    const alphabeticChar = /^(?=.*[a-zA-Z@_.\-])[a-zA-Z0-9@_.\-]+$/;
    const userLength = userName.length;
    const specialCharUser = alphabeticChar.test(userName);
    let errMsg = "";
    if (userLength === 0) {
      errMsg = "Inserisci nuovo username";
    } else if (!specialCharUser) {
      errMsg = " Deve contenere almeno un carattere non numerico. Caratteri speciali ammessi: “@“, “-“, “_” e “.”";
    } else if (userLength < 8) {
      errMsg = "Il nuovo Username deve contenere minimo 8 caratteri alfanumerici";
    } else if (userLength > 50) {
      errMsg = "Il nuovo Username deve contenere massimo 50 caratteri alfanumerici";
    }
    setUserErr(errMsg);
    if (confirmUserName !== userName) {
      setConfirmUserNameError("Il valore non corrisponde");
    } else {
      setConfirmUserNameError("");
    }
    if (confirmUserName == userName && errMsg == "") {
      return true;
    } else {
      return false;
    }
  };

  const changeUser = () => {
    setloading(true);
    if (handleValidation()) {
      axios.post(Url + "api/changeusername", {
        "new_alias": userName,
        "old_alias": ""
      }, {
        headers: {
          'Authorization': getStore("token")
        }
      }).then((res) => {
        setloading(false);
        if (res.data.response_code == "CR_7_30") {
          navigate("/usermodified");
        } else {
          setUserErr(res.data.response_desc);
        }
      })
    }
  };

  const date = new Date();
  const currentYear = date.getFullYear();

  return (
    <Container maxWidth="xl">
      <Grid container>
        <Grid class="logoContainer" item xs={12} sm={12} md={12}>
          <img class="logo" src={Sella}></img>
        </Grid>
      </Grid>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <Intestazione>Recupera il tuo Codice Cliente o Username</Intestazione>
        </Grid>
      </Grid>
      <br></br>
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <CompilaCampi>
            Compila i campi per recuperare il Codice Cliente o Username
          </CompilaCampi>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={0} sm={0} md={3}></Grid>
        <Grid item xs={12} sm={12} md={6}>
          <div class="Line-8"></div>
        </Grid>
        <Grid item xs={0} sm={0} md={3}></Grid>
      </Grid>

      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <ReimpostaUserName>Reimposta il tuo Username</ReimpostaUserName>
        </Grid>
      </Grid>

      <TextFields container spacing={2}>
        <Grid item xs={0} sm={0} md={3}></Grid>

        <Grid item xs={12} sm={12} md={3}>
          <FormControl variant="standard" fullWidth>
            <InputLabel class="Lable" htmlFor="userName-input">
              Username (min. 8 caratteri alfanumerici)
            </InputLabel>
            <CssTextField
              type={showPassword ? "text" : "password"}
              onChange={(e) => setUserName(e.target.value)}
              hidden
              id="userName-input"
              variant="outlined"
              fullWidth
              defaultValue=""
              InputProps={{
                endAdornment: <InputAdornment position="end"><IconButton
                  aria-label="toggle password visibility"
                  onPointerDown={handleClickShowPassword}
                  onPointerUp={handleClickShowPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton></InputAdornment>
              }}
            ></CssTextField>
            <Errors>{UserError}</Errors>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={3}>
          <FormControl variant="standard" fullWidth>
            <InputLabel class="Lable" htmlFor="conferma-input">
              Conferma username
            </InputLabel>
            <CssTextField
              type={showPassword2 ? "text" : "password"}
              onChange={(e) => setConfirmUserName(e.target.value)}
              variant="outlined"
              fullWidth
              defaultValue=""
              id="conferma-input"
              InputProps={{
                endAdornment: <InputAdornment position="end"><IconButton
                  aria-label="toggle password visibility"
                  onPointerDown={handleClickShowPassword2}
                  onPointerUp={handleClickShowPassword2}
                  edge="end"
                >
                  {showPassword2 ? <VisibilityOff /> : <Visibility />}
                </IconButton></InputAdornment>
              }}
            />
            <Errors>{confirmUserNameError}</Errors>
          </FormControl>
        </Grid>
        <Grid item xs={0} sm={0} md={3}></Grid>
      </TextFields>
      <BloccoImportante container>
        <Grid item xs={0} sm={0} md={3}></Grid>
        <Grid item xs={12} sm={12} md={6}>
          <DivImportante>
            <ContenutoDiv>
              Importante: ricordati di salvare il tuo nuovo username in un posto
              sicuro.
            </ContenutoDiv>
          </DivImportante>
        </Grid>
        <Grid item xs={0} sm={0} md={3}></Grid>
      </BloccoImportante>

      <Buttons container spacing={2}>
        <Grid item xs={0} sm={0} md={4}></Grid>
        <Grid item xs={12} sm={12} md={2}>
          <BackButton fullWidth disabled={loading} onClick={close} variant="contained">
            CHIUDI
          </BackButton>
        </Grid>
        <Grid item xs={12} sm={12} md={2}>
          <UpButton
            disabled={loading}
            fullWidth
            variant="contained"
            onClick={changeUser}
          >
            PROSEGUI
          </UpButton>
        </Grid>
      </Buttons>

      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <HelperText>
            Vuoi maggiori informazioni o hai bisogno di assistenza?
          </HelperText>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <SimpleBox>
            <ContactLink href="/banca-on-line/contatti-e-assistenza">contatta il servizio clienti</ContactLink>
          </SimpleBox>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={0} sm={0} md={3}></Grid>
        <Grid item xs={12} sm={12} md={6}>
          <div class="Line-8"></div>
        </Grid>
        <Grid item xs={0} sm={0} md={3}></Grid>
      </Grid>

      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <Informativa>
            © 1996-{currentYear} - Banca Sella S.p.A. - PI 02224410023 - Privacy
          </Informativa>
        </Grid>
      </Grid>
    </Container>
  );
}

export default MakeNewUserName;
